const link = {
    apiUrl: 'https://dashboard.healthnovoindia.com',
    apiUrl1: 'https://healthnovoindia.in/node',
    cdnurl: 'https://healthnovoindia.in/cdnurl'
};

export default link;